import React from 'react'

function FullScreenWarning() {
  const enterFullscreen = () => {
    const el = document.documentElement;
    if (el.requestFullscreen) {
      el.requestFullscreen().catch((err) => {
        console.error("Fullscreen error:", err);
      });
    }
  };
  return (
    <div className="fullscreen-warning section">
      <h2>You must stay in fullscreen mode to continue the exam.</h2>
      <button onClick={enterFullscreen} className="next-btn">
        Return to Fullscreen
      </button>
    </div>
  );
}

export default FullScreenWarning